import request from 'config/axios'

const API_ACTIVITY_AREAS = '/resources/v2/activity-areas'

const getActivityAreas = () => request.get(API_ACTIVITY_AREAS)

export default getActivityAreas

